export const SearchByImageIconLg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 13.8911 18.7985 15.6173 17.6436 16.9365L22.8535 22.1465C23.0487 22.3418 23.0487 22.6583 22.8535 22.8535C22.6583 23.0487 22.3418 23.0487 22.1465 22.8535L16.9365 17.6436C15.6173 18.7985 13.8911 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5ZM12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5Z"
      fill="currentcolor"
    />
    <path
      d="M17.7617 1H18.9998C21.209 1 22.9998 2.79086 22.9998 5V6.23809M6.23809 23.0001H5C2.79086 23.0001 1 21.2092 1 19.0001V17.762"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 6.23809V5C1 2.79086 2.79086 1 5 1H6.23809"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchByImageIconMd = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.92871 3.5C10.3745 3.50008 12.3574 5.48292 12.3574 7.92871C12.3574 8.97139 11.9956 9.92888 11.3926 10.6855L15.1396 14.4326C15.3346 14.6278 15.3346 14.9444 15.1396 15.1396C14.9445 15.3348 14.6279 15.3347 14.4326 15.1396L10.6855 11.3926C9.92888 11.9956 8.97139 12.3574 7.92871 12.3574C5.48292 12.3574 3.50008 10.3745 3.5 7.92871C3.5 5.48288 5.48288 3.5 7.92871 3.5ZM7.92871 4.5C6.03516 4.5 4.5 6.03516 4.5 7.92871C4.50008 9.82219 6.03521 11.3574 7.92871 11.3574C9.82215 11.3573 11.3573 9.82215 11.3574 7.92871C11.3574 6.03521 9.82219 4.50008 7.92871 4.5Z"
      fill="currentcolor"
    />
    <path
      d="M4.33333 15C2.49238 15 1 13.5076 1 11.6667M1 4.33333C1 2.49238 2.49238 1 4.33333 1M11.6667 1C13.5076 1 15 2.49238 15 4.33333"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
